<template lang="html">
  <div @keydown="keyCheck">
    <markdown-editor v-model="entry.content" ref="markdownEditor" :highlight="true" :configs="simpleMdeConfig"></markdown-editor>
    <div class="picker-cover" @click="autoCloseCal(true)">
      <div @click="autoCloseCal(false)" class="cal-box">
        <datepicker :highlighted="highlighted" class="picker" ref="picker" :inline="true" @selected="datepickerSelected" :color="$root.data.settings.theme.primaryColour"></datepicker>
      </div>
    </div>
    <modal name="modify-tags" height="350" :classes="['modify-tags-modal', 'v--modal']">
      <div class="title">
        <h2>Change Tags</h2>
      </div>
      <div class="modal-body">
        <h4>Add Tag:</h4>
        <vue-input v-model="currentTag" placeholder="Please input"></vue-input>

        <h4>Current Tags:</h4>
        <v-tag-list v-model="entry.tags" theme="materialize" :removable="true"></v-tag-list>

        <div class="align-bottom-right">
          <vue-button type="primary" @click="keyCheck('createTag');$modal.hide('modify-tags')">
            Done
          </vue-button>
        </div>

      </div>
    </modal>

  </div>
</template>

<script>
import hljs from 'highlight.js';
import markdownEditor from 'vue-simplemde/src/markdown-editor';
import datepicker from 'vuejs-datepicker';
import VTagList from 'v-tag-list';
const throttle = require("lodash.throttle")

window.hljs = hljs;

export default {
  name: 'Composer',
  components: {
    markdownEditor,
    datepicker,
    VTagList
  },
  data: function() {
    return {
      date: undefined,
      currentTag: "",
      highlighted: {
        dates: []
      },
      entry: {
        content: '',
        tags: []
      },
      calClose: true,
      simpleMdeConfig: {
        autofocus: false,
        spellChecker: false,
        status: false,
        simplemde: null,
        toolbar: [
          'bold', 'italic', 'heading', '|',
          'code', 'quote', 'ordered-list', 'unordered-list', '|',
          'link', 'image', '|',
          'preview', 'side-by-side', 'fullscreen', '|',
          {
            name: 'tags',
            action: function() {
              window.modalHook.show('modify-tags')
            },
            className: 'fas fa-tags',
            title: 'Choose Tags'
          },
          {
            name: 'date',
            action: function() {
              document.querySelector('.picker-cover').style.display = 'flex';
            },
            className: 'fa fa-calendar entry-date',
            title: 'Choose Date'
          }
        ]
      }
    }
  },
  watch: {
    'entry.content': function() {
      this.save()
    },
    'entry.tags': function() {
      this.save()
    }
  },
  mounted: function() {
    var src = document.querySelector('.entry-date')
    var el = document.createElement('span');
    el.classList.add('entry-date-inner')
    src.appendChild(el);

    this.journalUpdate()
    window.modalHook = this.$modal;

    if (this.$parent.autoOpenEditor) {
      this.$parent.autoOpenEditor = false;
      this.datepickerSelected(this.$parent.date)
    }
  },
  computed: {
    journal: function() {
      return this.$root.data.journals[this.$parent.currentJournal]
    }
  },
  methods: {
    // debug functions
    showAlert(a) {
      alert(a)
    },

    // editor-related functions
    setEditorCursor(pos) {
      // var pos = {
      //   line: 2,
      //   ch: 1
      // }
      this.$children[0].simplemde.codemirror.setSelection(pos, pos);
    },

    // data-related functions
    save: throttle(function() {
      this.entry.modifiedDateTime = new Date();
      this.$parent.autoSave()
    }, 3000),
    loadDateData() {
      var d = this.$parent.date.dateString();
      this.entry = this.$root.data.journals[this.$parent.currentJournal].getEntry(d)
    },
    journalUpdate() {
      function makeDate(s) {
        return new Date(s)
      }
      this.highlighted.dates = Object.keys(this.$root.data.journals[this.$parent.currentJournal].entries).map(makeDate)
    },

    // date-related functions
    formatDate(date) {
      var options = {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      };

      return date.toLocaleDateString("en-AU", options)
    },
    datepickerSelected(val) {
      if (val) {
        this.updateDate(val)
      }
      if (!this.date) {
        var pc = document.querySelector('.picker-cover')
        pc.style.transition = 'none';
        pc.style.background = 'rgba(127, 0, 0, .4)';
        setTimeout(function() {
          pc.style.transition = '0.2s';
          pc.style.background = 'rgba(0, 0, 0, .4)';
        }, 20);
        return
      }

      document.querySelector('.picker-cover').style.opacity = 0;
      setTimeout(function() {
        document.querySelector('.picker-cover').style.display = 'none';
        document.querySelector('.picker-cover').style.opacity = 1;
      }, 200);
    },
    updateDate(newDate) {
      if (this.$parent.date) {
        this.journal.purge(this.$parent.date.dateString())
      }
      this.$parent.date = newDate;
      this.date = newDate;
      document.querySelector('.entry-date-inner').innerHTML = this.formatDate(newDate)
      this.loadDateData()
      this.journalUpdate()
    },
    autoCloseCal(close) {
      if (this.calClose && close) {
        this.datepickerSelected()
      }
      this.calClose = close;
    },
    keyCheck(ev) {
      if (ev.code == 'Escape') {
        this.datepickerSelected();
      } else if ((ev.code == 'Enter' && ev.path[3].classList.contains('modify-tags-modal')) || ev == "createTag") {
        var t = this.currentTag.toLowerCase()
        if (t.length && !this.entry.tags.includes(t)) {
          this.entry.tags.push(t);
        }
        this.currentTag = "";
      }
    }
  }
}
</script>

<style lang="css">
@import '~simplemde/dist/simplemde.min.css';
@import '~github-markdown-css';
@import '~highlight.js/styles/github-gist.css';
@import '../assets/styles/chips.css';
@import url('https://fonts.googleapis.com/icon?family=Material+Icons');

.markdown-editor {
  height: 100%;
  overflow: hidden;
  position: relative;
}

/* Markdown editor styles */
.markdown-editor .CodeMirror {
  border: none;
  height: calc(100% - 71px);
  border-top: 1px solid #ddd;
  overflow-y: auto !important;
  border-radius: 0px;
  padding: 10px 20px;
}
.editor-preview {
  padding: 10px 20px;
}
.markdown-editor .CodeMirror-scroll {
  height: calc(100% - 71px);
}

.markdown-editor>.editor-toolbar {
  border: none;
  border-radius: 0px;
}

.editor-preview > pre,
.editor-preview-side > pre {
  padding: 1em .75em;
  border-radius: 5px;
}
.markdown-editor .cm-formatting-code-block,
.markdown-editor .cm-comment {
  font-family: monospace;
  font-size: 1.15em;
}
.editor-toolbar > a.fa{
  outline: none;
}
.entry-date {
  width: auto !important;
  padding: 0 5px;
}
.entry-date::before {
  padding-right: 7px;
}
.entry-date-inner {
  font-family: -apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
}

.picker-cover {
  display: flex;
  position: relative;
  top: -100%;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
  opacity: 1;
  background: rgba(0, 0, 0, .4);
  align-items: center;
  justify-content: center;
  transition: 0.2s;
}

.vdp-datepicker__calendar .cell.highlighted {
  background-color: white !important;
  background-image: linear-gradient(135deg, var(--shade0) -1px, var(--shade0) 8px, transparent 9px, transparent) !important;
  background-repeat: no-repeat !important;
}
.vdp-datepicker__calendar .cell.highlighted.today, .vdp-datepicker__calendar .cell.today {
  color: #e70000 !important;
  font-weight: 500;
}
.vdp-datepicker__calendar .cell.weekend, .vdp-datepicker__calendar .cell.weekend.highlighted {
    background-color: #e4e4e4 !important;
}
.vdp-datepicker__calendar .cell.selected, .vdp-datepicker__calendar .cell.highlighted.selected {
    background-color: var(--shade0) !important;
    color: white !important;
}
.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day:hover, .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month:hover, .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year:hover {
    border: 1px solid var(--shade0) !important;
}
.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day.today {
  /* background-color: rgba(255, 0, 0, 0.3); */
}

.modify-tags-modal > .title {
  color: #3b3b3b;
  padding: 15px;
  height: 37px;
  border-bottom: 1px solid grey;
}
.modify-tags-modal > .title > h2 {
  margin: 0px;
  font-size: 25px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.modify-tags-modal > .modal-body {
  padding: 20px;
}
.modify-tags-modal > .modal-body > h4 {
  margin: .7em 0;
}
.modify-tags-modal .v-tag-list {
  height: 74px;
  overflow-y: auto;
}
.modify-tags-modal .v-tag-list .close {
  width: 16px;
  overflow: hidden;
}
.modify-tags-modal .align-bottom-right {
  text-align: right;
  bottom: 0px;
}
</style>
